export default "https://cdn-static.gokick.com/assets/ba7f9a5518cadaf73eb1329111c0735c5df64124/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";